import { useEffect, useState } from 'react';

import VerifyWarriorsWallet from '~/components/auth/VerifyWallet';
import Section from '~/components/hero/LandingPage/Section';
import MainNav from '~/components/navbar/MainNav';
import { WarriorsByTournament } from '~/components/tournament/signup/SignUpWarriorList';
import {
  PromptToSignUp,
  SignUpForm,
} from '~/components/tournament/signup/Verify';
import { OPENSEA_COLLECTION_URL } from '~/constants';
import { ConnectedProviders } from '~/contextProviders/connectedProviders';
import { useGameAuthentication } from '~/contextProviders/GameAuthenticationProvider';
import { useWarriorAuthentication } from '~/contextProviders/WarriorAuthenticationProvider';
import { useSubmitTournamentRegister } from '~/hooks/tournament/useSubmitTournamentRegister';
import { VerifyTournamentRegister } from '~/pages/tournaments/verify';

const SignUpPage = () => {
  const { warriors, isLoading, isLoadingMore, hasMore, loadMore } =
    useWarriorAuthentication();
  const { accessToken, connectedWallet } = useGameAuthentication();
  const [showForm, setShowForm] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const {
    mutate: submitTournamentMutation,
    isSuccess: tournamentRegisterIsSuccess,
  } = useSubmitTournamentRegister();


  useEffect(() => {
    if (accessToken && !isSuccess && connectedWallet) {
      submitTournamentMutation(
        {
          token: accessToken,
          walletAddress: connectedWallet,
        },
        {
          onError: (err: any) => {
            console.log('err', err);
          },
        }
      );
    }
  }, [accessToken, isSuccess, submitTournamentMutation, connectedWallet]);

  if (tournamentRegisterIsSuccess) {
    return <VerifyTournamentRegister />;
  }

  if (hasMore && !isLoadingMore) {
    loadMore();
  }

  return (
    <div className="container container--landing-page container--revival">
      <header className="landing-page__header">
        <MainNav showConnectWallet={true} />
      </header>
      <div
        className={`content-wrapper ${
          warriors && warriors.length ? '' : 'content-wrapper--small'
        }`}
      >
        <Section className="landing-page__section--hero">
          <h2 className="landing-page__h2 landing-page__h2--amarante naming-title-spacing">
            {isSuccess ? 'Verify your email' : 'Enter the Tournaments'}
          </h2>
        </Section>
        {/* <TournamentReward /> */}
        <div className="battle-nav-tournament-explainer">
          <p className="grid-potions__text grid-potions__explainer">New Tournament every three weeks</p>
          <p className="grid-potions__text grid-potions__explainer">Signup to be automatically enrolled in upcoming tournaments</p>
          <p className="grid-potions__text grid-potions__explainer">Battles every week day, full FAQ and schedule <a className="link" href="https://fictivekin.notion.site/Peacefall-Battle-FAQ-f7d9120ed5774babb34fd95c5f7cc306">here</a></p>
        </div>

        {showForm && <SignUpForm setIsSuccess={setIsSuccess} />}

        {warriors && Boolean(warriors.length) && (
          <>
            {!showForm && <PromptToSignUp setShowForm={setShowForm} />}
            <WarriorsByTournament warriors={warriors} />
          </>
        )}
        <>
          {accessToken ? (
            <>
              {(isLoading || isLoadingMore) && (
                <div>Loading {isLoadingMore ? 'more' : ''} Warriors...</div>
              )}
              {!(isLoading || isLoadingMore) && !warriors?.length && (
                <>
                  <div>
                    You don&apos;t own any Warriors in this wallet and must be
                    obtained to enter the Tournaments.
                  </div>
                  <div>
                    Warriors can be purchased on{' '}
                    <a
                      className="underline"
                      href={OPENSEA_COLLECTION_URL}
                    >
                      OpenSea
                    </a>
                    .
                  </div>
                </>
              )}
            </>
          ) : (
            <div className="name-wallet-connect">
              <VerifyWarriorsWallet message={'Verify & Signup'} />
            </div>
          )}
        </>
      </div>
    </div>
  );
};

const SignUp = () => {
  return (
    <ConnectedProviders accessTokenRequired={true}>
      <SignUpPage />
    </ConnectedProviders>
  );
};

export default SignUp;
